<template>
    <a-form class='ant-advanced-search-form' layout="inline">
         <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div id="stepNumCharts" style="width:100%;height:240px;margin:0 auto;"></div>
           </a-col>
           <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="locus-button-group health-button">
                    <a-button-group>
                      <a-button type="primary" size="small">日</a-button>
                      <a-button size="small">周</a-button>
                      <a-button size="small">月</a-button>
                      <a-button size="small"><img src="../../assets/locus_date_icon.png" alt="" /></a-button>
                    </a-button-group>
                    <a-button-group>
                        <span class="locus-time">2018/12/28 — 2018/12/29</span>
                    </a-button-group>
                 </div>
                 <div id="heartCharts" style="width:100%;height:240px;margin:0 auto;"></div>
           </a-col>
         </a-row>
     </a-form>
</template>

<script>
    // 引入基本模板
    let echarts = require('echarts/lib/echarts')
    // 引入折线图组件
    require('echarts/lib/chart/line')
    // 引入提示框和title组件
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')

    export default {
        name: 'ZHealthLine',
        data() {
            return {}
        },
        mounted(){
            this.SetStepEhcarts()           
            this.SetHeartEhcarts()
        },
        methods:{
            SetStepEhcarts() {                
                  // 基于准备好的dom，初始化echarts实例
                  let stepChart = echarts.init(document.getElementById('stepNumCharts'));
                  
                  // 使用刚指定的配置项和数据显示图表。
                  stepChart.setOption(
                  // 指定图表的配置项和数据
                  {
                        title: {
                             text: '步数',
                             textStyle: {
                                fontSize: 12,
                                color: '#333'
                             },
                             top: '0',
                             right: '20'
                         },
                         tooltip: {
                             trigger: 'axis'
                         },
                         grid: {
                              left: '3%',
                              right: '3%',
                              top: '4%',
                              containLabel: true
                         },
                         xAxis: [{
                             type: 'category',
                             data: ['28', '29', '30', '1', '2', '3', '4'],
                             axisLine: {
                                lineStyle: {
                                    width: 1,
                                    color: '#666'
                                }
                             },
                             axisTick: {
                                inside: true,
                                length: 4
                             },
                             min: 0,
                             minInterval: 1
                         }],
                         yAxis: [{
                             type: 'value',
                             splitLine: {
                                show: false
                             },
                             min: 0,
                             axisLine: {
                                lineStyle: {
                                    width: 1,
                                    color: '#666'
                                }
                             },
                             axisTick: {
                                inside: true,
                                length: 4
                             }
                         }],
                         series: [{
                             name: '步数',
                             type: 'line',
                             smooth: true,
                             symbolSize: 8,
                             itemStyle: {
                                normal: {
                                   color: '#3d86ef',
                                   lineStyle: {
                                      color: "#3d86ef"
                                   }
                                }
                             },
                             data: [2820, 4932, 5901, 3934, 3290, 5330, 4320]
                         }]
                  });
                  window.addEventListener("resize",function(){
                     stepChart.resize();
                  });
            },
            SetHeartEhcarts() {
                  //基于准备好的dom，初始化echarts实例
                  let heartChart = echarts.init(document.getElementById('heartCharts'));                
                  //使用刚指定的配置项和数据显示图表。
                  heartChart.setOption(
                  //指定图表的配置项和数据
                  {
                        title: {
                             text: '心率',
                             textStyle: {
                                fontSize: 12,
                                color: '#333'
                             },
                             top: '0',
                             right: '20'
                         },
                         tooltip: {
                             trigger: 'axis'
                         },
                         grid: {
                              left: '3%',
                              right: '3%',
                              top: '4%',
                              containLabel: true
                         },
                         xAxis: [{
                             type: 'category',
                             data: ['28', '29', '30', '1', '2', '3', '4'],
                             axisLine: {
                                lineStyle: {
                                    width: 1,
                                    color: '#666'
                                }
                             },
                             axisTick: {
                                inside: true,
                                length: 4
                             },
                             min: 0,
                             minInterval: 1
                         }],
                         yAxis: [{
                             type: 'value',
                             splitLine: {
                                show: false
                             },
                             min: 0,
                             axisLine: {
                                lineStyle: {
                                    width: 1,
                                    color: '#666'
                                }
                             },
                             axisTick: {
                                inside: true,
                                length: 4
                             }
                         }],
                         series: [{
                             name: '心率',
                             type: 'line',
                             smooth: true,
                             symbolSize: 8,
                             itemStyle: {
                                normal: {
                                   color: '#3d86ef',
                                   lineStyle: {
                                      color: "#3d86ef"
                                   }
                                }
                             },
                             data: [89, 100, 92, 112, 100, 103, 124]
                         }]
                  });
                  window.addEventListener("resize",function(){
                     heartChart.resize();
                  });
            }
        }
    }    
</script>
<style>
    

    
</style>